import { render, staticRenderFns } from "./IgnoreBillModal.vue?vue&type=template&id=520b7a28&"
import script from "./IgnoreBillModal.vue?vue&type=script&lang=js&"
export * from "./IgnoreBillModal.vue?vue&type=script&lang=js&"
import style0 from "./IgnoreBillModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports